import React from 'react'
import PropTypes from 'prop-types'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'

import styles from './../style/Konfiguraciya.module.scss'

import { Container, Image, OverlayTrigger, Tooltip } from 'react-bootstrap'

import WhiteBlockTitle from './WhiteBlockTitle'
import GreenButton from './GreenButton'
import StormcloudButton from './StormcloudButton'
import FeedbackForm from './FeedbackForm'

class Konfiguraciya extends React.Component {
  constructor(props) {
    super(props)
    this.swiperInstances = [] // Массив для хранения экземпляров Swiper
    this.state = {
      activeIndices: [],
      show_feedback: false
    }
  }

  showFeedback = ( formname ) => {
    this.setState({ show_feedback: true, formname: formname });
  }
  closeFeedback = () => {
    this.setState({ show_feedback: false });
  }

  // Сохраняем экземпляр Swiper при инициализации
  handleSwiperInit = (swiper, index) => {
    this.swiperInstances[index] = swiper
    this.setState(prevState => {
      const newActiveIndices = [...prevState.activeIndices]
      newActiveIndices[index] = swiper.realIndex
      return { activeIndices: newActiveIndices }
    })
  }

  nextSlide = (index) => {
    if (this.swiperInstances[index]) {
      this.swiperInstances[index].slideNext()
    }
  }

  prevSlide = (index) => {
    if (this.swiperInstances[index]) {
      this.swiperInstances[index].slidePrev()
    }
  }

  handleSlideChange = (swiper, index) => {
    this.setState(prevState => {
      const newActiveIndices = [...prevState.activeIndices]
      newActiveIndices[index] = swiper.realIndex
      return { activeIndices: newActiveIndices }
    })
  }

  render() {
    const { data } = this.props,
    { show_feedback } = this.state

    return (
      <section className={styles.section}>
        <Container>
          <WhiteBlockTitle
            title={data?.title}
          />
          <div className={styles.content}>
            {data?.lists.map((list, k) => (
              <div key={k} className={styles.list}>
                {list.length > 0 &&
                  <>
                    <Swiper
                      modules={[Navigation]}
                      spaceBetween={10}
                      slidesPerView={1}
                      loop={true}
                      onSwiper={(swiper) => this.handleSwiperInit(swiper, k)}
                      onSlideChange={(swiper) => this.handleSlideChange(swiper, k)}
                    >
                      {list.map((slide, j) => (
                        <SwiperSlide key={j}>
                          <div className={styles.list_content}>
                            <div className={styles.list_content_block1}>
                              <div className={styles.list_content_topline}>
                                <div className={styles.list_content_icon}>
                                  <Image src={slide?.icon} width={15} height={15} alt={`И`} />
                                </div>
                                <div dangerouslySetInnerHTML={{__html: slide?.vidi}} />
                              </div>
                              <div className={styles.list_content_name}>{slide?.name}</div>
                              <div className={styles.list_content_text}>{slide?.text}</div>
                              <OverlayTrigger
                                key={`top-${k}-${j}`}
                                placement={`top`}
                                overlay={
                                  <Tooltip id={`tooltip-top-${k}-${j}`}>
                                    <div className={styles.list_content_conf} dangerouslySetInnerHTML={{__html: slide?.conf}} />
                                  </Tooltip>
                                }
                              >
                                <div>
                                  <StormcloudButton
                                    text={`Подробное описание`}
                                    width={267}
                                    action={() => {  }}
                                    className={styles.list_content_btn}
                                  />
                                </div>
                              </OverlayTrigger>
                            </div>
                            <div className={styles.list_content_block2}>
                              <div className={styles.list_content_block2_image}>
                                <Image src={slide?.image} width={164} height={100} alt={slide?.name} />
                              </div>
                              <GreenButton
                                text={`Конфигурация`}
                                width={165}
                                action={() => this.showFeedback()}
                              />
                            </div>
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                    <FeedbackForm
                      title={`Конфигурация`}
                      text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
                      btn={`Отправить`}
                      data={[]}
                      show={show_feedback}
                      handleClose={() => this.closeFeedback()}
                    />
                    <div className={styles.slydenav_btns}>
                      <div 
                        className={styles.slydenav_btn} 
                        onClick={() => this.prevSlide(k)}
                        role="button"
                        tabIndex={0}
                      >
                        <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M11.3212 4.49913H1.67882M1.67882 4.49913L5.53576 8.35608M1.67882 4.49913L5.53576 0.642184" stroke="white" strokeLinecap="round" />
                        </svg>
                      </div>
                      <div></div>
                      <div 
                        className={styles.slydenav_btn} 
                        onClick={() => this.nextSlide(k)}
                        role="button"
                        tabIndex={0}
                      >
                        <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0.678817 4.50087H10.3212M10.3212 4.50087L6.46424 0.643924M10.3212 4.50087L6.46424 8.35782" stroke="white" strokeLinecap="round" />
                        </svg>
                      </div>
                    </div>
                  </>
                }
              </div>
            ))}
          </div>
        </Container>
      </section>
    )
  }
}

Konfiguraciya.propTypes = {
  data: PropTypes.object
}

Konfiguraciya.defaultProps = {
  data: {}
}

export default Konfiguraciya